
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M3.47443 14.8835C2.79083 12.8623 2.84753 10.664 3.63444 8.68078C4.42134 6.69753 5.88724 5.05835 7.77063 4.05568C9.65402 3.05301 11.8324 2.75207 13.9171 3.20656C16.0018 3.66104 17.8572 4.84138 19.1523 6.537M19.1523 6.537V3.00832M19.1523 6.537H15.7407"></path><path d="M20.5256 9.11654C21.2092 11.1377 21.1525 13.336 20.3656 15.3193C19.5787 17.3025 18.1128 18.9417 16.2294 19.9444C14.346 20.947 12.1676 21.248 10.0829 20.7935C7.99825 20.339 6.14283 19.1587 4.84769 17.4631M4.84769 17.4631V20.9917M4.84769 17.4631H8.25927"></path><ellipse cx="15" cy="12" rx="2" ry="2.5"></ellipse><mask id="mask0_2184_97" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="6" y="7" width="6" height="10"><path d="M7 15V9L9 12L11 15V9"></path></mask><g mask="url(#mask0_2184_97)"><rect x="6" y="9" width="6" height="6"></rect></g><path d="M18 15V14"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiAutoNumber",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
